import type { FC, ReactNode } from 'react'

import { useEffect } from 'react'

// First-load curtain. Everything here is CSS (see .preloader in globals.css),
// so it plays before any JavaScript and never blocks content if scripts fail.
// After it has gone, the intro delay is shortened so later pages animate in
// straight after the page transition.
const Preloader: FC = (): ReactNode => {
    useEffect(() => {
        const id = window.setTimeout(() => {
            document.documentElement.style.setProperty('--intro-delay', '0.55s')
        }, 2400)

        return () => window.clearTimeout(id)
    }, [])

    return (
        <div aria-hidden='true' className='preloader'>
            <div className='type-label flex justify-between text-paper/60'>
                <span>
                    Fit Design
                </span>

                <span>
                    London / Gdańsk
                </span>
            </div>

            <div>
                <div className='flex items-end justify-between gap-6'>
                    <p className='type-label max-w-[16rem] text-paper/60'>
                        Websites designed and built since 2012
                    </p>

                    <p className='type-display flex items-start tabular-nums'>
                        <span className='preloader-count' />
                        <span className='text-volt'>
                            +
                        </span>
                    </p>
                </div>

                <div className='mt-5 h-px bg-paper/15'>
                    <div className='preloader-bar h-px bg-volt' />
                </div>
            </div>
        </div>
    )
}

export default Preloader
